const mutations = {
  RESET(state: StateObj) {
    state.profile = {};
  },
  UPDATE_PROFILE(state: StateObj, profile: Profile) {
    state.profile = { ...state.profile, ...profile };
  }
};

export default mutations;
